export function formatLocale (value?: string | number, decimals?: number) {
  if (value === null || value === undefined) {
    return value
  }

  if (decimals !== null && decimals !== undefined) {
    return value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
  }

  return value.toLocaleString()
}

export function roundNumber (value: number, decimals: number = 1) {
  return performRoundOperation(value, decimals, Math.round)
}
export function floorNumber (value: number, decimals: number = 1) {
  return performRoundOperation(value, decimals, Math.floor)
}
export function ceilNumber (value: number, decimals: number = 1) {
  return performRoundOperation(value, decimals, Math.ceil)
}

function performRoundOperation (value: number, decimals: number, op: (number) => number) {
  if (value) {
    const exp = Math.pow(10, decimals)
    return op((value + Number.EPSILON) * exp) / exp
  } else if (value === 0) {
    return value
  }
  return value
}
